import React from 'react';
import { OrganizationUnitType } from '@institutions/graphql';
import { Form } from 'antd';
import {
  ContentContainer,
  AlignedInfo,
  Title,
  Gutter,
  TextAreaEmojiPicker,
} from '@common/components';
import { Answers } from './suppliers-management-locations-update-steps';
import {
  SupplierDetailsSummary,
  TieringRadioTierType,
} from '@institutions/components';

export function SuppliersManagementLocationsUpdateStepReview({
  supplierName,
  selectedTier,
  selectedRoles,
  organizationUnits,
  selectedOrganizationUnitsIds,
  removedOrganizationUnitsIds,
  onNotesChange,
  answers,
  showActiveItemsStep,
  requiredNotes,
}: {
  supplierName?: string;
  selectedTier: TieringRadioTierType;
  selectedRoles: string[];
  organizationUnits: OrganizationUnitType[];
  selectedOrganizationUnitsIds: string[];
  removedOrganizationUnitsIds: string[];
  onNotesChange: (notes: string) => void;
  answers: Answers;
  showActiveItemsStep: boolean;
  requiredNotes: boolean;
}) {
  const selectedOrganizationUnits: OrganizationUnitType[] = [];
  const removedOrganizationUnits: OrganizationUnitType[] = [];

  organizationUnits.forEach((unit) => {
    if (selectedOrganizationUnitsIds.includes(unit.id))
      selectedOrganizationUnits.push(unit);
    if (removedOrganizationUnitsIds.includes(unit.id))
      removedOrganizationUnits.push(unit);
  });

  const activeItemsColumn = showActiveItemsStep && (
    <>
      <Gutter size="md" direction="bottom">
        <Title size="h3" weight="medium">
          Active Items
        </Title>
      </Gutter>

      <AlignedInfo
        content={[
          [
            'Active Submissions',
            answers?.rejectSubmissions ? 'Reject' : 'Keep as-is',
          ],
          ['Pending Offers', answers?.retractOffers ? 'Retract' : 'Keep as-is'],
          [
            'Extension Offers',
            answers?.retractExtensionOffers ? 'Retract' : 'Keep as-is',
          ],
        ]}
      />
    </>
  );

  return (
    <>
      <ContentContainer title={supplierName}>
        <Gutter size="xl" direction="bottom">
          <SupplierDetailsSummary
            selectedTier={selectedTier}
            canUserSeeTiering={!!selectedTier.name}
            selectedRoles={selectedRoles}
            selectedOrganizationUnits={selectedOrganizationUnits}
            removedOrganizationUnits={removedOrganizationUnits}
            extraColumn={activeItemsColumn}
          />
        </Gutter>
        <div style={{ maxWidth: 600 }}>
          <Form layout="vertical">
            <Form.Item
              label="Note"
              name="note"
              rules={[{ required: requiredNotes, message: 'Note is required' }]}
            >
              <TextAreaEmojiPicker
                autoFocus
                placeholder="Type a message to include with your invite"
                maxLength={500}
                autoSize={{ minRows: 5 }}
                onChange={(value) => onNotesChange(value.trim())}
              />
            </Form.Item>
          </Form>
        </div>
      </ContentContainer>
    </>
  );
}
